module.exports = __webpack_public_path__ + "img/default_dialog_main_image.bc129577.png";